import React from 'react';
import { Toaster } from 'sonner';
import useLenis from '@/hooks/useLenis';
import Nav from '@/components/landing/Nav';
import Hero from '@/components/landing/Hero';
import FiturScale from '@/components/landing/FiturScale';
import WhatIs from '@/components/landing/WhatIs';
import ProgramVideo from '@/components/landing/ProgramVideo';
import SoloVsTribu from '@/components/landing/SoloVsTribu';
import TargetProfiles from '@/components/landing/TargetProfiles';
import Phases from '@/components/landing/Phases';
import BrandTape from '@/components/landing/BrandTape';
import Benefits from '@/components/landing/Benefits';
import Itinerary from '@/components/landing/Itinerary';
import Matrix from '@/components/landing/Matrix';
import MentalPrep from '@/components/landing/MentalPrep';
import Testimonials from '@/components/landing/Testimonials';
import Pricing from '@/components/landing/Pricing';
import Includes from '@/components/landing/Includes';
import LeadForm from '@/components/landing/LeadForm';
import FAQ from '@/components/landing/FAQ';
import Footer from '@/components/landing/Footer';
import WhatsAppFloat from '@/components/landing/WhatsAppFloat';
import StickyCta from '@/components/landing/StickyCta';

const Landing = () => {
    useLenis();
    return (
        <div className="relative bg-[color:var(--bg)] text-[color:var(--ink)] overflow-x-clip">
            <Toaster
                position="bottom-right"
                theme="dark"
                toastOptions={{
                    style: {
                        background: 'rgba(19,17,16,0.96)',
                        color: '#FAF8F5',
                        border: '1px solid rgba(255,255,255,0.14)',
                        fontFamily: 'var(--font-sans)',
                        borderRadius: '4px',
                    },
                }}
            />
            <Nav />
            <main>
                <Hero />
                <FiturScale />
                <WhatIs />
                <ProgramVideo />
                <SoloVsTribu />
                <TargetProfiles />
                <BrandTape />
                <Phases />
                <Benefits />
                <BrandTape text="RESERVA HOY · SEP 30 CIERRA LANZAMIENTO · CUPOS LIMITADOS" />
                <Itinerary />
                <Matrix />
                <MentalPrep />
                <Testimonials />
                <Pricing />
                <Includes />
                <LeadForm />
                <FAQ />
            </main>
            <Footer />
            <WhatsAppFloat />
            <StickyCta />
        </div>
    );
};

export default Landing;
